<template>
    <div class="specificationUnavailable" :class="itemClasses" :style="itemStyle"></div>
</template>

<script lang="ts">
    import {DeploymentSpecification} from '@cquential/api';
    import {CSSProperties} from 'vue';
    import {WorkScheduleGridPosition} from '@/types/types';
    import WorkScheduleUtil from '@/util/WorkScheduleUtil';
    import {DeploymentSpecificationTypes} from '@/types/enums/DeploymentSpecificationTypes';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class DeploymentSpecificationUnavailable extends Vue {
        @Prop({required: true}) public beginDateTimeDeployment!: Date;
        @Prop({required: true}) public endDateTimeDeployment!: Date;
        @Prop({required: true}) public beginOfDay!: Date;
        @Prop({required: true}) public specification!: DeploymentSpecification;

        public get itemStyle(): CSSProperties {
            const position: WorkScheduleGridPosition = WorkScheduleUtil.getPositionInHours(this.beginDateTimeDeployment, this.specification.begin, this.specification.end);

            return {
                '--offset-left': 'calc(' + position.left + ' * var(--hour-cell-width))',
                '--width': 'calc(' + position.width + ' * var(--hour-cell-width))',
            };
        }

        public get itemClasses(): Record<string, boolean> {
            return {
                specificationBreak: this.specification.typeId === DeploymentSpecificationTypes.BREAK,
            };
        }
    }
</script>

<style lang="scss" scoped>
    .specificationUnavailable {
        position: absolute;
        left: var(--offset-left);
        width: var(--width);
        height: 100%;
        background: var(--work-schedule-specification-unavailable-background);
    }

    .specificationBreak {
        background: var(--work-schedule-specification-break-gradient-background);
    }
</style>
